export default {"src":"/_next/static/media/arrow-blue.5437dc8b.svg","height":6,"width":66,"blurWidth":0,"blurHeight":0};